var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioPause({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-430 -478)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0D1116",
    width: 4,
    height: 14,
    rx: 1,
    transform: "translate(430 478)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0D1116",
    width: 4,
    height: 14,
    rx: 1,
    transform: "translate(436 478)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioPause);
export default __webpack_public_path__ + "static/media/audio_pause.5afcbad18b39550566db36d00efd6e1a.svg";
export { ForwardRef as ReactComponent };